import { FileImageOutlined } from "@ant-design/icons";
import { Form, Input, Modal, Select, Switch } from "antd";
import React, { useEffect, useState } from "react";
import { api } from "services/api";
import Swal from "sweetalert2";
import { getBase64Img } from "utils";

export const EditProductModal: React.FC<any> = ({ ...props }) => {
	const [isActive, setIsActive] = useState<boolean>(false);
	const [imageWasEdited, setImageWasEdited] = useState<boolean>(false);
	const [option, setOption] = useState<string>("");

	const {
		form,
		isOpen,
		setCurrentImgURL,
		setIsOpen,
		productStatus,
		currentImgURL,
		setProductStatus,
		productIsHighlight,
		setProductIsHighlight,
		setProducts,
		currentProductInfo,
	} = props;
	const { Option } = Select;

	const handleRegister = (values: any) => {
		api
			.put(`/products/${currentProductInfo?.id}`, values)
			.then((result) => {
				if ([200, 201].includes(result.status)) {
					const {
						data: { feedback },
					} = result;
					setProducts && setProducts(undefined);
					api.get("/products").then((res) => {
						setProducts && setProducts(res.data.data.products);
					});
					form.resetFields();
					Swal.fire({
						icon: "success",
						text: feedback["success"],
						confirmButtonColor: "#63b8cd",
					}).then(() => {
						setIsOpen(false);
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			})
			.catch((err) => {
				const status = err.response.status;
				const { feedback, errors } = err.response?.data;
				if (
					status === 400 ||
					status === 401 ||
					status === 404 ||
					status === 403 ||
					status === 500
				) {
					Swal.fire({
						icon: "error",
						text: feedback["error"]
							? feedback["error"]
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
				if (status === 422) {
					Swal.fire({
						icon: "error",
						text: errors?.message
							? errors?.message
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			});
	};

	useEffect(() => {
		if (isOpen) {
			form.setFieldsValue({
				title: currentProductInfo?.title,
				description: currentProductInfo?.description,
				link: currentProductInfo?.link,
				visibility:
					currentProductInfo?.visibility === "public" ? "public" : "private",
			});
			setOption(
				currentProductInfo?.visibility === "public" ? "public" : "private"
			);
			setCurrentImgURL(
				currentProductInfo?.image ? currentProductInfo?.image : ""
			);
			setProductStatus(currentProductInfo?.status === "publish" ? true : false);
			setProductIsHighlight(
				currentProductInfo?.is_highlight === true ? true : false
			);
			setIsActive(currentProductInfo?.is_active === true ? true : false);
		}
		// eslint-disable-next-line
	}, [isOpen]);

	return (
		<Modal
			title={<p style={{ margin: 0 }}>Editar produto</p>}
			open={isOpen}
			maskClosable={false}
			okText="Editar produto"
			cancelText="Cancelar"
			onOk={() => {
				form
					.validateFields()
					.then((values: any) => {
						const allValues = imageWasEdited
							? {
									...values,
									status: productStatus ? "publish" : "pending",
									is_highlight: productIsHighlight,
									visibility: option ? option : "",
									is_active: isActive,
									image: currentImgURL,
							  }
							: {
									...values,
									status: productStatus ? "publish" : "pending",
									is_highlight: productIsHighlight,
									visibility: option ? option : "",
									is_active: isActive,
							  };

						handleRegister(allValues);
						console.log(allValues);
						setCurrentImgURL("");
						setProductStatus(false);
						setProductIsHighlight(false);
						setIsActive(false);
					})
					.catch((info: any) => {
						console.log("Validate Failed:", info);
					});
			}}
			onCancel={() => {
				setIsOpen(!isOpen);
				setCurrentImgURL("");
				setProductStatus(false);
				setProductIsHighlight(false);
				setIsActive(false);
				form.resetFields();
			}}
			className="m-modal-product"
		>
			<Form form={form} name="new-course" autoComplete="off">
				<div className="m-product-modal">
					<div className="m-product-modal__login-info">
						<div className="m-product-modal__login-info__avatar">
							{currentImgURL ? (
								<img src={currentImgURL} alt="" width="100%" height="100%" />
							) : (
								<FileImageOutlined />
							)}
							<label
								htmlFor="avatar"
								className="m-product-modal__login-info__avatar__btn"
							>
								Escolha uma foto
							</label>
							<Input
								id="avatar"
								type="file"
								accept="image/*"
								style={{ display: "none" }}
								onClick={() => {}}
								onChange={(e) => {
									if (e.target.files?.[0]) {
										setImageWasEdited(true);
										getBase64Img(e.target.files?.[0] as Blob, setCurrentImgURL);
									}
								}}
							/>
						</div>
						<div
							className="m-product-modal__login-info__inputs"
							style={{ justifyContent: "space-evenly" }}
						>
							<Form.Item
								name="title"
								rules={[
									{
										required: true,
										message: "Título necessário",
									},
								]}
							>
								<Input placeholder="Título do produto" />
							</Form.Item>
							<Form.Item
								name="description"
								rules={[
									{
										required: true,
										message: "Descrição necessária",
									},
								]}
							>
								<Input placeholder="Descrição do produto" />
							</Form.Item>
							<Form.Item
								name="link"
								rules={[
									{
										required: true,
										message: "Link necessário",
									},
								]}
							>
								<Input placeholder="Link do produto" />
							</Form.Item>

							<div
								style={{
									display: "flex",
									width: "91%",
									alignItems: "center",
									justifyContent: "end",
								}}
							>
								<Form.Item
									name="visibility"
									rules={[
										{
											required: true,
											message: "Visibilidade necessária",
										},
									]}
									style={{ margin: 0, width: "100%" }}
								>
									<Select
										placeholder="Visibilidade"
										className="m-product-modal__select"
										value={option}
										onChange={(e) => setOption(e)}
									>
										<Option value="public">Público</Option>
										<Option value="private">Privado</Option>
									</Select>
								</Form.Item>
								<div
									className="m-product-modal__status"
									style={{ marginRight: "10px", marginLeft: "10px" }}
								>
									<p>Publicado</p>
									<Switch
										checked={productStatus}
										onClick={(e) => setProductStatus(e)}
									/>
								</div>
								<div
									className="m-product-modal__status"
									style={{ marginRight: "15px" }}
								>
									<p>Destacar</p>
									<Switch
										checked={productIsHighlight}
										onClick={(e) => setProductIsHighlight(e)}
									/>
								</div>
								<div className="m-product-modal__status">
									<p>Ativo</p>
									<Switch checked={isActive} onClick={(e) => setIsActive(e)} />
								</div>
							</div>
						</div>
					</div>
				</div>
			</Form>
		</Modal>
	);
};
